/**
 * Payment Repository Interface
 * 결제 관리 데이터 레이어의 추상화 인터페이스
 */
export class IPaymentRepository {
  /**
   * KSPAY 결제 결과 콜백
   * @param {Object} data - KSPAY 결제 결과 데이터
   * @param {string} data.authyn - 승인여부 (O: 승인, X: 거절)
   * @param {string} data.trno - KSNET 거래번호
   * @param {string} data.trddt - 거래일자 (YYYYMMDD)
   * @param {string} data.trdtm - 거래시간 (hhmmss)
   * @param {string} data.amt - 금액
   * @param {string} data.authno - 승인번호/에러코드
   * @param {string} data.msg1 - 메시지1
   * @param {string} data.msg2 - 메시지2
   * @param {string} data.ordno - 주문번호 (transaction_id)
   * @returns {Promise<BaseResponse<any>>}
   */
  async kspayCallback(data) {
    throw new Error('Method must be implemented');
  }

  /**
   * 결제 정보 조회
   * @param {number} paymentId - 결제 ID
   * @returns {Promise<BaseResponse<any>>}
   */
  async getPayment(paymentId) {
    throw new Error('Method must be implemented');
  }

  /**
   * 주문별 결제 정보 조회
   * @param {number} orderId - 주문 ID
   * @returns {Promise<BaseResponse<any>>}
   */
  async getPaymentByOrder(orderId) {
    throw new Error('Method must be implemented');
  }
}
